














































import Vue from 'vue';
import { getContentArea } from '@/contentful';

interface Data {
  content: string;
  linkText: string;
  link: string;
  showAnnouncement: boolean;
}

export default Vue.extend({
  name: 'AnnouncementBanner',
  data(): Data {
    return {
      content: '',
      linkText: '',
      link: '',
      showAnnouncement: true,
    };
  },
  mounted() {
    this.getContent();
  },
  methods: {
    getContent(): void {
      getContentArea('announcement-banner-content')
        .then((data) => {
          if (data) {
            this.content = data.fields.content;
            if (data.fields.actions) {
              this.linkText = data.fields.actions.fields.actionDescription;
              this.link = data.fields.actions.fields.actionValue;
            }
          }
        });
    },
    isRoute(action): boolean {
      return action ? action.indexOf('route="') > -1 : false;
    },
    isLink(action): boolean {
      return action ? action.indexOf('link="') > -1 : false;
    },
    isSelfLink(action): boolean {
      return action ? action.indexOf('link:self="') > -1 : false;
    },
    constructRoute(action): string {
      let regex;
      if (this.isRoute(action)) {
        regex = /(route=")(.*)(")/g;
      } else if (this.isLink(action)) {
        regex = /(link=")(.*)(")/g;
      } else if (this.isSelfLink(action)) {
        regex = /(link:self=")(.*)(")/g;
      }
      return action.replace(regex, (match, a, b) => {
        return b;
      });
    },
  },
   watch: {
    showAnnouncement(val, oldVal) {
      this.$store.commit('hideAnnouncement');
    },
  },
});
